var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-item"},[_c('div',{staticClass:"option",class:_vm.borderClass,on:{"click":function($event){$event.stopPropagation();return _vm.goToRoute.apply(null, arguments)}}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.subItemIcon}})]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.sectionTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }